module.exports = __webpack_public_path__ + "static/Trabaja01-c6e64bb6fa987b27bfa814d95341f72e.jpg";